export const XBeneGesseritSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 114) * 98}
      viewBox="0 0 114 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.3504 1.00001C38.3504 0.999971 40.4932 3.80227 40.3504 7.49998C40.2076 11.1977 39.8504 15 35.3504 15C32.8168 15 33.3504 13 29.8504 13C25.5784 13 18.8504 14.5 13.8504 21C9.85039 26.2 9.85039 36.1667 10.3504 40.5C14.0171 38.1667 23.4409 33 31.8504 33C40.3504 33 48.1837 37.5 50.8504 40C54.3504 33 52.1504 25.1 57.3504 25.5C62.5504 25.9 60.3504 33 63.8504 40C65.6837 38 73.5725 33 82.8504 33C92.8504 33 100.684 38.5 103.85 42C104.517 39.5 105.756 30.7793 102.85 24C99.8504 17 93.3504 13 86.8504 11.5C83.8504 10.8077 82.8504 13.9999 79.8504 13C76.0556 11.7351 75.3504 11.5 75.3504 6.49994C75.3504 2.49994 76.3504 1 80.8504 1C85.3504 1 83.8504 4 85.8504 4.5C87.8504 5 103.542 5.85813 109.85 19C115.85 31.5 112.85 39 108.85 48.5C116.85 59.5 111.35 76 105.85 83.5C100.35 91 91.3504 94.5 88.3504 94.5C85.3504 94.5 84.2748 97 80.8504 97C75.8504 97 73.8504 94 73.8504 91C73.8504 88 74.8504 84 78.3504 83.5C81.8504 83 81.8504 85.5 85.3504 85C90.3001 84.2929 92.8504 83.5 99.8504 76C105.45 70 105.184 59.1667 103.85 55C100.85 57.8333 91.8903 64 83.8504 64C76.3504 64 67.1837 60.1667 63.8504 57C60.8504 61.4999 61.6504 73 56.8504 73C52.0504 73 53.8504 62.4999 50.8504 58C48.3504 60.5 41.8504 64 31.8504 64C21.8504 64 12.6837 57.8333 10.3504 55C9.51705 56.3333 10.3504 70 13.8504 75C18.2271 81.2525 22.3504 85 29.8504 85C32.2983 85 33.8504 83.5 35.3504 83.5C38.8859 83.5 40.3504 84.5 40.3504 89.5C40.3504 94.5 38.8504 97 35.3504 97C33.8504 97 32.8504 94.7727 29.8504 94.5C18.8504 93.5 5.94794 80.061 3.35039 74C-0.249617 65.6 2.35038 53.3333 5.35039 48.5C1.68372 48.3333 -0.599402 36.9054 2.35039 24C5.51704 10.1459 20.3504 5.49998 29.3504 3.99998C33.3504 3.33332 32.3504 1.00006 35.3504 1.00001Z"
        fill="url(#paint0_linear_277_26)"
        stroke="black"
      />
      <path
        d="M30.3504 41.4999C25.9504 41.4999 19.1837 45.9999 16.3504 48.4999C18.5171 50.4999 24.3504 54.4999 30.3504 54.4999C36.3504 54.4999 42.3504 52.4999 43.3504 47.4999C42.3504 43.9999 34.7504 41.4999 30.3504 41.4999Z"
        fill="black"
      />
      <path
        d="M83.3504 41.4999C87.7504 41.4999 94.5171 45.9999 97.3504 48.4999C95.1837 50.4999 89.3504 54.4999 83.3504 54.4999C77.3504 54.4999 71.3504 52.4999 70.3504 47.4999C71.3504 43.9999 78.9504 41.4999 83.3504 41.4999Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="paint0_linear_277_26"
          x1="57.1216"
          y1="1"
          x2="57.1216"
          y2="97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDDAF5" />
          <stop offset="1" stopColor="#C170D4" />
        </linearGradient>
      </defs>
    </svg>
  );
};
